import React from 'react';
import PropTypes from 'prop-types';
// widgets
import withStyles from '@material-ui/core/styles/withStyles';

import {
  primaryColor,
  dangerColor,
  successColor,
  roseColor,
  infoColor,
  warningColor,
  hexToRgb,
  whiteColor,
  blackColor,
  grayColor,
} from '../styles';

class CardTabs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.nav = React.createRef();
    this.state = {
      currentStep: 0,
      width: 100 / props.steps.length + '%',
      movingTabStyle: {
        transition: 'transform 0s',
      },
    };
    this.navigationStepChange = this.navigationStepChange.bind(this);
    this.refreshAnimation = this.refreshAnimation.bind(this);
    this.updateWidthProps = this.updateWidthProps.bind(this);
  }
  componentDidMount() {
    this.refreshAnimation(0);
    window.addEventListener('resize', this.updateWidthProps);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidthProps);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.steps.length !== nextProps.steps.length) {
      this.updateWidth(nextProps, true);
    }
  }
  updateWidthProps() {
    this.updateWidth(this.props);
  }
  updateWidth(props, reset) {
    const step = reset ? 0 : this.state.currentStep;
    this.setState(
      {
        width: 100 / props.steps.length + '%',
        currentStep: step,
      },
      () => setTimeout(() => this.refreshAnimation(step), 200)
    );
  }
  navigationStepChange(key) {
    if (this.props.steps) {
      this.setState({
        currentStep: key,
      });
      this.refreshAnimation(key);
    }
  }
  refreshAnimation(index) {
    var total_steps = this.props.steps.length;
    var move_distance = this.nav.current
      ? this.nav.current.children[0].getBoundingClientRect().width
      : 0;
    var index_temp = index;
    var vertical_level = 0;

    var step_width = move_distance - 26;
    move_distance = move_distance * index_temp;

    var current = index + 1;

    if (current === 1) {
      move_distance -= 6;
      step_width += this.props.extraMargin;
    } else if (current === total_steps) {
      move_distance -= this.props.extraMargin / 2;
      step_width += this.props.extraMargin;
    }

    var movingTabStyle = {
      width: step_width,
      left: this.props.extraMargin * -1,
      transform:
        'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
      transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)',
    };
    this.setState({ movingTabStyle: movingTabStyle });
  }
  render() {
    const { classes, color, steps, extraMargin } = this.props;
    const step = steps[this.state.currentStep];
    return (
      <div className={classes.cardTabsContainer}>
        <div className={classes.cardTabsNavigation}>
          <ul
            className={classes.nav}
            style={{
              left: extraMargin * -1 + 'px',
              width: 'calc(100% + ' + extraMargin * 2 + 'px',
            }}
            ref={this.nav}
          >
            {steps.map((prop, key) => {
              return (
                <li
                  className={classes.steps}
                  key={key}
                  style={{ width: this.state.width }}
                >
                  <div
                    className={classes.stepsAnchor}
                    onClick={() => this.navigationStepChange(key)}
                  >
                    {prop.stepName}
                  </div>
                </li>
              );
            })}
          </ul>
          <div
            className={classes.movingTab + ' ' + classes[color]}
            style={this.state.movingTabStyle}
          >
            {step.stepName}
          </div>
        </div>
        <div className={classes.content}>
          <step.stepComponent innerRef={(node) => (this[step.stepId] = node)} />
          {/*  {steps.map((prop, key) => {
            const stepContentClasses = cx({
              [classes.stepContentActive]: this.state.currentStep === key,
              [classes.stepContent]: this.state.currentStep !== key,
            });
            return (
              <div className={stepContentClasses} key={key}>
                <prop.stepComponent
                  innerRef={node => (this[prop.stepId] = node)}
                />
              </div>
            );
            })}*/}
        </div>
      </div>
    );
  }
}

CardTabs.defaultProps = {
  color: 'primary',
  extraMargin: 0,
};

CardTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepName: PropTypes.string.isRequired,
      stepComponent: PropTypes.elementType.isRequired,
      stepId: PropTypes.string.isRequired,
    })
  ).isRequired,
  color: PropTypes.oneOf([
    'primary',
    'warning',
    'danger',
    'success',
    'info',
    'rose',
  ]),
  extraMargin: PropTypes.number,
};

const cardTabsStyle = {
  cardTabsContainer: {},
  card: {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    boxShadow: '0 1px 4px 0 rgba(' + hexToRgb(blackColor) + ', 0.14)',
    borderRadius: '6px',
    color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
    background: whiteColor,
    transition: 'all 300ms linear',
    minHeight: '410px',
  },
  cardTabsHeader: {
    textAlign: 'center',
    padding: '25px 0 35px',
  },
  title: {
    margin: '0',
  },
  subtitle: {
    margin: '5px 0 0',
  },
  cardTabsNavigation: {
    position: 'relative',
  },
  nav: {
    position: 'relative',
    marginTop: '20px',
    paddingLeft: '0',
    marginBottom: '0',
    listStyle: 'none',
    backgroundColor: 'rgba(' + hexToRgb(grayColor[17]) + ', 0.2)',
    '&:after,&:before': {
      display: 'table',
      content: '" "',
    },
    '&:after': {
      boxSizing: 'border-box',
    },
  },
  steps: {
    marginLeft: '0',
    textAlign: 'center',
    // float: "left",
    // display: "block",
    position: 'relative',
    display: 'inline-block',
  },
  stepsAnchor: {
    cursor: 'pointer',
    position: 'relative',
    display: 'block',
    padding: '10px 0px',
    textDecoration: 'none',
    transition: 'all .3s',
    border: '0 !important',
    borderRadius: '30px',
    lineHeight: '18px',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: '500',
    minWidth: '100px',
    textAlign: 'center',
    // color: grayColor[6] + " !important",
  },
  content: {
    minHeight: '340px',
    padding: '20px 15px',
  },
  stepContent: {
    display: 'none',
  },
  stepContentActive: {
    display: 'block',
  },
  movingTab: {
    position: 'absolute',
    textAlign: 'center',
    padding: '12px',
    fontSize: '14px',
    textTransform: 'uppercase',
    WebkitFontSmoothing: 'subpixel-antialiased',
    top: '-4px',
    left: '0px',
    borderRadius: '4px',
    color: whiteColor,
    cursor: 'pointer',
    fontWeight: '500',
  },
  primary: {
    backgroundColor: primaryColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(primaryColor[0]) +
      ', 0.4)',
  },
  warning: {
    backgroundColor: warningColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(warningColor[0]) +
      ', 0.4)',
  },
  danger: {
    backgroundColor: dangerColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(dangerColor[0]) +
      ', 0.4)',
  },
  success: {
    backgroundColor: successColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(successColor[0]) +
      ', 0.4)',
  },
  info: {
    backgroundColor: infoColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(infoColor[0]) +
      ', 0.4)',
  },
  rose: {
    backgroundColor: roseColor[0],
    boxShadow:
      '0 4px 20px 0px rgba(' +
      hexToRgb(blackColor) +
      ', 0.14), 0 7px 10px -5px rgba(' +
      hexToRgb(roseColor[0]) +
      ', 0.4)',
  },
  footer: {
    padding: '0 15px',
  },
  left: {
    float: 'left!important',
  },
  right: {
    float: 'right!important',
  },
  clearfix: {
    '&:after,&:before': {
      display: 'table',
      content: '" "',
    },
    clear: 'both',
  },
};

export default withStyles(cardTabsStyle)(CardTabs);
